<template>
  <a-col :span="24" class="card">
    <a-row class="scope__row">
      <a-col>
        <a-row :class="`root${hasPortfolio ? ' has_portfolio' : ''}`">
          <div @click="onClick" class="top-item">
            <div :class="`title${item.parentId ? '' : '__top'}`">
              {{ getTitle() }}
            </div>
            <div class="shortnames-container">
              <div class="portfolio-tags">
                <span
                  class="tag"
                  v-for="(shortName, index) in item.briefcaseShortNames"
                  :key="`udc-portfolio-` + index"
                >
                  {{ shortName }}
                </span>
              </div>
              <div class="collapsed" :class="!isActive ? 'active' : ''">
                <a-spin :spinning="isLoading">
                  <img src="@/assets/icons/circle-chevron-right.svg" alt="" />
                </a-spin>
              </div>
            </div>
          </div>
        </a-row>
      </a-col>
      <a-col class="scope__checked">
        <c-checkbox
          :checked="isChecked"
          @change="changeHandler"
          :disabled="disabled"
        >
          Выбрать
        </c-checkbox>
      </a-col>
    </a-row>
    <a-row class="cards" v-if="items?.length > 0 && isActive">
      <project-udc-item
        v-for="children in items"
        :key="children.notation"
        :item="children"
        :delete-udc-id="deleteUdcId"
        :disabled="disabled"
        @update="onUpdate"
      />
    </a-row>
  </a-col>
</template>

<script setup>
  import { computed, onMounted, ref, watch } from 'vue';
  import CCheckbox from '@/components/UI/CCheckbox.vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';

  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
    deleteUdcId: Number, // ИД УДК для которого нужно убрать связь с проектом
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const route = useRoute();
  const api = useApi();
  const emit = defineEmits(['update']);
  const items = ref([]);
  const isLoading = ref(false);
  const isActive = ref(false);
  const isChecked = ref(false);
  const itemsProcessed = ref(false);

  const hasPortfolio = computed(() => {
    return (
      props.item.briefcaseShortNames &&
      props.item.briefcaseShortNames.length > 0
    );
  });

  onMounted(() => {
    isChecked.value = !!props.item.projectUdcId;
  });

  // Deleting UDC event
  watch(
    () => props.deleteUdcId,
    (newValue) => {
      if (props.item.id === newValue && isChecked.value) {
        isChecked.value = false;
      }
    }
  );

  const getTitle = () => {
    return `${props.item.notation}. ${props.item.caption}`;
  };

  const onClick = async () => {
    if (!isActive.value) {
      await getUdc();
    }

    isActive.value = !isActive.value;
  };

  const getUdc = async () => {
    if (itemsProcessed.value) return;

    isLoading.value = true;
    try {
      const response = await api.udc.getDescendants(
        new URLSearchParams({
          topUdcId: props.item.id,
          projectId: route.params.id,
        })
      );
      items.value = response.udcList.items;
      itemsProcessed.value = true;
    } catch (error) {
      console.error('error', error);
    } finally {
      isLoading.value = false;
    }
  };

  const changeHandler = () => {
    isChecked.value = !isChecked.value;
    emit('update', { udc: props.item, isChecked: isChecked.value });
  };

  const onUpdate = (update) => {
    emit('update', update);
  };
</script>

<style scoped lang="scss">
  @use "@/assets/styles/_colors.scss" as *;

  .ant-row:not(:first-child) {
    margin-top: 8px;
    margin-left: 10px;
  }

  .scope__row {
    flex-wrap: nowrap;

    & > .ant-col:first-child {
      flex: 1 1 100%;
    }

    .root {
      background-color: $color-bg-secondary-grey;
      border-radius: 7px;
      padding: 14px;

      &.has_portfolio {
        background-color: #72c81e33;
        border: 1px solid $color-btn-primary;
      }

      .top-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .title {
          color: $color-text-primary;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;

          &__top {
            font-weight: 700;
          }
        }
      }

      .active {
        transform: rotate(90deg);
        transition: all 0.2s ease-in;
      }

      .collapsed {
        transition: all 0.2s ease-in;
        user-select: none;
        width: 24px;
        height: 24px;
      }
    }
  }

  .scope__checked {
    display: flex;
    flex: 0 0 215px;
    padding-left: 20px;
    align-items: center;

    .margined {
      margin-top: 30px;
    }
  }

  .cards {
    row-gap: 8px;
  }

  .shortnames-container {
    display: flex;
    flex-direction: row;
  }

  .portfolio-tags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-right: 40px;

    .tag {
      color: $color-text-secondary-white;
      background: $color-bg-seconary-black-95;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      border-radius: 30px;
      height: 24px;
      padding: 2px 10px;
      margin: 0 2px;
    }
  }
</style>
